import { toast } from "react-hot-toast";
import { FiTrash2, FiDownload, FiUsers } from "react-icons/fi";
import { ImSpinner3 } from "react-icons/im";
import { FileItem } from "../Components";
import { downloadFile } from "./downloadUtils";
import { MESSAGES } from "../constants";

const FolderView = ({
  currentFolder,
  openFolder,
  handleDeleteItem,
  openAccessModal,
  actionLoading,
  setActionLoading,
}) => {
  const onDownloadFile = async (fileObj) => {
    setActionLoading((prev) => ({ ...prev, downloading: fileObj.id }));
    try {
      await downloadFile(fileObj.file);
      toast.success(MESSAGES.FILE_DOWNLOAD_SUCCESS);
    } catch {
      toast.error(MESSAGES.FILE_DOWNLOAD_FAILED);
    } finally {
      setActionLoading((prev) => ({ ...prev, downloading: null }));
    }
  };

  if (!currentFolder)
    return <div className="text-gray-500 text-center">No folders found.</div>;

  const folders = currentFolder.subfolders || [];
  const files = currentFolder.files || [];

  return (
    <div className="space-y-2">
      {/* Folders */}
      {folders.map((folder) => (
        <div
          key={folder.id}
          className="flex items-center justify-between px-4 py-2 hover:bg-blue-50 rounded group"
        >
          <div
            onClick={() => openFolder(folder)}
            className="text-secondary font-medium cursor-pointer"
          >
            📁 {folder.name}
          </div>
          <div className="flex items-center gap-6">
            <FiUsers
              onClick={() => openAccessModal(folder)}
              className="text-primary cursor-pointer hover:text-primary/90"
              title="Manage folder Access"
            />

            {actionLoading.deleting === folder.id ? (
              <ImSpinner3 className="animate-spin text-red-500" />
            ) : (
              <FiTrash2
                onClick={() => handleDeleteItem("folder", folder)}
                className="text-red-500 cursor-pointer hover:text-red-600"
              />
            )}
          </div>
        </div>
      ))}

      {/* Files */}
      {files.map((file) => (
        <div
          key={file.id}
          className="flex items-center justify-between px-4 py-2 hover:bg-gray-50 rounded group"
        >
          <FileItem file={file} />
          <div className="flex gap-6 items-center">
            {actionLoading.downloading === file.id ? (
              <ImSpinner3 className="animate-spin text-secondary" />
            ) : (
              <FiDownload
                onClick={() => {
                  onDownloadFile(file);
                }}
                className="text-secondary cursor-pointer"
              />
            )}

            <FiUsers
              onClick={() => openAccessModal(file, "file")}
              className="text-primary cursor-pointer hover:text-primary/90"
              title="Manage File Access"
            />

            {actionLoading.deleting === file.id ? (
              <ImSpinner3 className="animate-spin text-red-500" />
            ) : (
              <FiTrash2
                onClick={() => handleDeleteItem("file", file)}
                className="text-red-500 cursor-pointer hover:text-red-600"
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FolderView;
